export default __webpack_public_path__ + "static/media/Girdle of Pandemonium.2b4a7329.jpg";